import axios from 'axios';
import { Post } from '@/service/request/server';
import { envConfig } from '../../../env';

const source = envConfig.formalServer + '/source';
// const source = 'https://servertest.cottongame.com/source'

const formalSource = envConfig.formalServer + "/source"  // 正式服 serverstore
// const formalSource = 'https://server.cottongame.com/source'  // 正式服 serverstore


//--- ProjectPath.vue
export const findProjectData = params => axios.post(source + '/findProjectData', params)       // 获取项目路径信息
export const addProjectData = params => axios.post(source + '/addProjectData', params)         // 添加项目路径信息
export const updateProjectData = params => axios.post(source + '/updateProjectData', params, { // 修改项目路径信息
    headers: {
        'Content-Type': 'application/json;charset=UTF-8'
    }
})
export const deleteProjectData = params => axios.post(source + '/deleteProjectData', params)   // 删除项目路径信息



//--- ProjectFile.vue
export const getProjectData = params => axios.post(source + '/getProjectData', params)       // 获取项目信息
export function selectProjectData() {
    return Post( envConfig.formalServer +"/source/getProjectData", {})
}
export const findProjectFilePage = params => axios.post(source + '/findProjectFilePage', params)         // 获取项目文件信息
export const delProjectFile = params => axios.post(source + '/delProjectFile', params)       // 删除项目文件信息
export const delProjectFileForFormal = params => axios.post(formalSource + '/delProjectFile', params)    // 删除项目文件信息 - 正式服



//--- ProjectInfo.vue
//export const getProjectData + 1                                                               // 获取项目信息 + 1
export const findPageVoFileInfo = params => axios.post(source + '/findPageVoFileInfo', params)  // 获取文件信息
export const updAnnounceStatus = params => axios.post(source + '/updAnnounceStatus', params)    // 发布文件信息
export const downloadFile_vue = params => axios.post(source + '/downloadFile_vue', params, {    // 下载文件信息
    'responseType': 'blob'
})
export const delFileInfo = params => axios.post(source + '/delFileInfo', params)                // 删除文件信息

export const updAnnounceStatusFormal = params => axios.post(formalSource + '/updAnnounceStatus', params)  // 发布文件信息 - 正式服
export const downloadFileFormal_vue = params => axios.post(formalSource + '/downloadFile_vue', params, {  // 下载文件信息 - 正式服
    'responseType': 'blob'
})
export const delFileInfoFormal = params => axios.post(formalSource + '/delFileInfo', params)              // 删除文件信息 - 正式服



//--- Upload.vue
//export const getProjectData + 1                                                               // 获取项目信息 + 1
export const uploadFiles = (params, param) => axios.post(source + '/uploadFiles', params, {     // 文件上传
    onUploadProgress: ProgressEvent => {
        const complete = parseInt(
            ((ProgressEvent.loaded / ProgressEvent.total) * 100) | 0, 10
        );
        param.onProgress({ percent: complete });
    }
});

// export function uploadFilesForFormal(params, param) {
//     console.log("asdf");
//     console.log(params);
//     return Post(formalSource + '/uploadFiles', params, {
//         headers: {
//             'Content-Type': 'multipart/form-data'
//         },
//         onUploadProgress: ProgressEvent => {
//             const complete = parseInt(
//                 ((ProgressEvent.loaded / ProgressEvent.total) * 100) | 0, 10
//             )
//             param.onProgress({ percent: complete })
//         }
//     })
// }

export const uploadFilesForFormal = (params, param) => {
    return axios.post(formalSource + '/uploadFiles', params, { // 文件上传 - 正式服
        onUploadProgress: ProgressEvent => {
            const complete = parseInt(
                ((ProgressEvent.loaded / ProgressEvent.total) * 100) | 0, 10
            );
            param.onProgress({ percent: complete });
        }
    });
};

export const uploadFileChunk = (params, onUploadProgress) => axios.post('http://127.0.0.1:8084/uploadFileChunk', params, { // 文件分块上传
    headers: {
        'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
});

export const mergeFileChunk = (params) => axios.post('http://127.0.0.1:8084/mergeFileChunk', params);           // 文件合成
export const checkUploadProgress = (params) => axios.post('http://127.0.0.1:8084/checkUploadProgress', params); // 检查已上传的分片
